import React, { useContext } from 'react';
import ActiveControl from '../../../components/ActiveControl';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import useIncidentReasonService from '../../../app/services/hooks/useIncidentReasonService';

interface Props {
    id: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const IncidentReasonSwitchChange = ({ id, checkValue, callbackSuccess }: Props) => {
    const [checked, setChecked] = React.useState<boolean>(checkValue);

    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { activeIncidentReason, fetchingActiveIncidentReason } = useIncidentReasonService();

    const active = (value: boolean) => {
        setChecked(value);

        activeIncidentReason(id, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });

                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();

                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={id} callback={active} />;
};

export default IncidentReasonSwitchChange;
